




























































import { Component, Vue } from "vue-property-decorator";
// @ts-ignore
import { Carousel, Slide } from "vue-carousel";
@Component({
  components: { Carousel, Slide },
})
export default class Slides extends Vue {
  i = 0;

  get content() {
    return this.$store.getters.getCarouselContent;
  }
  get loaded() {
    return typeof this.content != "undefined";
  }

  get isAuthenticated() {
    return this.$store.getters.isAuthenticated;
  }
}
